import { Divider } from '@mui/material'
import floatingMenuStyles from '@/components/FloatingMenuPopup/index.module.scss'
import { providerLabel } from './agentModelControlOptions'
import { isProviderSelected, providerKey } from './AiAskBarHomeRightAgentSelect.helpers'
import MockEntries from './AiAskBarHomeRightAgentSelectMockEntries'
import Row from './AiAskBarHomeRightAgentSelectRow'

export default function AiAskBarHomeRightAgentSelectProviderEntries({
  autoOption,
  providers,
  catalog,
  selection,
  hoveredProvider,
  onProviderEnter,
  onSelect,
  mock,
}) {
  return (
    <>
      {autoOption ? (
        <>
          <Row
            label={autoOption.label}
            isSelected={selection.selectedId === autoOption.value}
            onClick={() => onSelect(autoOption.value)}
            onKeyDown={(e) => e.key === 'Enter' && onSelect(autoOption.value)}
          />
          {mock ? <MockEntries mock={mock} onRowEnter={() => onProviderEnter(null, null)} /> : null}
          <Divider className={floatingMenuStyles.divider} />
        </>
      ) : null}
      {providers.map((provider) => (
        <Row
          key={provider}
          label={providerLabel(provider)}
          isSelected={isProviderSelected(provider, catalog.models, selection.selectedId)}
          isActive={providerKey(provider) === providerKey(hoveredProvider)}
          showChevron
          onMouseEnter={(e) => onProviderEnter(provider, e.currentTarget)}
          onClick={(e) => onProviderEnter(provider, e.currentTarget)}
          onKeyDown={(e) => e.key === 'Enter' && onProviderEnter(provider, e.currentTarget)}
        />
      ))}
    </>
  )
}
